var path = '/embed/component/embed-playlist/tpl/embed-playlist.html';
var html = "<div class=\"col-xs-12 tm-embed-playlist\"> <div ng-if=$ctrl.ready> <thismoment-playlist aria-label={{$ctrl.name}} card-options=$ctrl.cardOptions display-search=$ctrl.displaySearch force-single-column=$ctrl.forceSingleColumn load-items=\"$ctrl.loadItems(limit, offset, search, order, randomcontent, success, error)\" loader-color=$ctrl.loaderColor layout=$ctrl.layout layout-options=$ctrl.layoutOptions max-column-count=$ctrl.maxColumnCount paginator-limit=$ctrl.paginatorLimit playlist-id=$ctrl.playlistId playlist-order=$ctrl.playlistOrder></thismoment-playlist> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/embed/component/embed-playlist/tpl/embed-playlist.html
// module id = 440
// module chunks = 1 3